import { useCallback } from 'react';
import { SetURLSearchParams, useLocation, useSearchParams } from 'react-router-dom';

/* useSearchParams for UI state kept in the URL (tabs, filters). The setter replaces the
   history entry, so tab switches don't pile up Back steps, and keeps location.state, so
   a detail page keeps its caller's `from` label (and BackLink still goes back) after
   the user switches tabs. Plain setSearchParams drops the state. */
export const useUrlParams = (): [URLSearchParams, SetURLSearchParams] => {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const state: unknown = location.state;
  const set = useCallback<SetURLSearchParams>(
    (next, options) => setParams(next, { replace: true, state, ...options }),
    [setParams, state],
  );
  return [params, set];
};

export default useUrlParams;
